import nexusProcurementHtml from '@/assets/Artifacts/nexus-procurement.html?raw'
import nexusCrmTestReportMarkdown from '@/assets/Artifacts/nexus-crm-test-report.md?raw'
import interfaceManagementCapability from './content/interface-management-capability.md?raw'
import { buildWorkflowTimeline } from '../streaming/buildWorkflowTimeline.js'
import { buildSelectionSwitchBlock } from './demoSelectionSwitch.js'
import { buildFileWriteNarration, buildStepNarration } from './stepNarrationCopy.js'
import {
  NEXUS_APPLICATION_ACCESS_TABLE,
  NEXUS_CONNECTED_APP_BLOCKS,
  NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME,
} from './nexusIntegrationsDemo.js'
import {
  ZOHO_CRM_INTEGRATION_AI_LOG_STEPS_BUILD,
  ZOHO_CRM_INTEGRATION_AI_LOG_STEPS_INITIAL,
  ZOHO_CRM_INTEGRATION_BEFORE_BUILD_MARKDOWN,
} from './zohoCrmIntegrationDemoContent.js'

/** Demo copy and trace payloads for the NexusB2B website + CRM trigger thread. */

export const WEBSITE_CRM_CRM_INTEGRATION_INTRO_MARKDOWN =
  "Let me build a comprehensive **Salesforce CRM** integration API with FastAPI — OAuth2 auth, lead and opportunity sync, **HubSpot SRM** supplier records, and **Procurify** purchase-request hooks, plus webhook handlers for incoming CRM events."

export const WEBSITE_CRM_USER_PROMPT =
  'Excellent! I liked the plan that you create , Now go ahead & create a website for me & ensure to test a demo user and by connecting to the CRM to send a trigger'

export const WEBSITE_CRM_USER_PROMPT_SHORT =
  'Now go ahead & create a website for me & ensure to test a demo user and by connecting to the CRM to send a trigger'

export const WEBSITE_CRM_DEPLOY_PLAN_USER_PROMPT =
  'no go ahead & create the website as per the development plan following the integrations and crendential given in the requirement document & also deploy and test the platform'

export const WEBSITE_CRM_PHASE1_THREAD_TITLE = 'Design System — Extraction'

export const WEBSITE_CRM_PHASE2_THREAD_TITLE = 'Design System — Tokens & Showcase'

export const WEBSITE_CRM_THOUGHT_DETAILS = [
  `The user approved the development plan and wants the NexusB2B procurement website built — plus a demo-user test and CRM trigger in the same response.`,
  `Plan of attack:

• Scaffold the static site from the plan (hero, catalog, RFQ flow)
• Connect **Salesforce CRM**, **HubSpot SRM**, and **Procurify** for the RFQ → procurement flow
• Run the Playwright demo-user test and fire live CRM + procurement triggers`,
  `I'll reuse the interface-management capability for the HTML preview panel, then wire Salesforce, HubSpot, and Procurify without waiting for confirmation.`,
  `Demo user persona: demo.procurement@acmecorp.example — bulk laptop RFQ through the catalog cart, then live triggers to Salesforce and Procurify.`,
  `Building the site now, then connecting CRM…`,
]

export const WEBSITE_CRM_INTRO_MARKDOWN =
  "I'll build the NexusB2B procurement website from the plan — hero, catalog, RFQ flow, and integration clients — then connect **Salesforce CRM**, **HubSpot SRM**, and **Procurify**, run the demo-user test, and send triggers in this same response."

export const WEBSITE_CRM_BEFORE_BUILD_MARKDOWN =
  "Scaffolding `nexus-b2b-site/` now — I'll write the HTML, add CRM + procurement integration clients, and build the static site."

export const WEBSITE_CRM_CONNECT_TRANSITION_MARKDOWN =
  'The site preview is ready. Connecting **Salesforce**, **HubSpot**, and **Procurify** now to run the demo-user checkout test and send triggers.'

export const WEBSITE_CRM_CONNECT_AFTER_MARKDOWN =
  '✅ **All milestones passed.** The demo-user checkout succeeded, CRM and procurement triggers fired, and Stripe + Mailchimp are ready for payments and nurture emails. Full execution details are below.'

export const WEBSITE_CRM_STRIPE_MAILCHIMP_MARKDOWN =
  '🔗 Next I\'ll wire **Stripe** for checkout payments and **Mailchimp** for nurture emails alongside **Salesforce**, **HubSpot**, and **Procurify**. Checking your workspace connections…'

export const WEBSITE_CRM_APPLICATION_ACCESS_TABLE_DATA = NEXUS_APPLICATION_ACCESS_TABLE
